import { createLocaleTextHook } from './localeText'
import { dictionary } from './core-dictionary'

export const useCoreLocaleText = createLocaleTextHook({
  dictionary,
})
